<template>
    <!-- <div class="md:grid md:grid-cols-3 md:gap-6">
        <jet-section-title>
            <template #title><slot name="title"></slot></template>
            <template #description><slot name="description"></slot></template>
        </jet-section-title>

        <div class="mt-5 md:mt-0 md:col-span-2">
            <form @submit.prevent="$emit('submitted')">
                <div class="px-4 py-5 bg-white sm:p-6 shadow"
                    :class="hasActions ? 'sm:rounded-tl-md sm:rounded-tr-md' : 'sm:rounded-md'">
                    <div class="grid grid-cols-6 gap-6">
                        <slot name="form"></slot>
                    </div>
                </div>

                <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow sm:rounded-bl-md sm:rounded-br-md" v-if="hasActions">
                    <slot name="actions"></slot>
                </div>
            </form>
        </div>
    </div> -->
<!-- <div class="col-12 row"> -->
    <!-- <div :class="'col-xs-12 col-sm-10 offset-sm-1 '+ classes + ' q-mt-lg'"> -->
    <div :class="'q-mt-md q-col-gutter-s '+(fullWidth ? 'col-12' : 'col-xs-12 col-sm-10 col-md-6')">
    <!-- <div class="q-mt-md col-grow"> -->

<!-- <q-btn label="appCreate Reload" @click="appCreateReload()" /> -->

        <!-- <form @submit.prevent="$emit('submitted')" @change="someThingChanged()"> -->
        <!-- <form @submit.prevent="$emit('submitted'); edition.isDirty = false"> -->
        <!-- <form @submit.prevent="$emit('submitted'); form.isDirty = false"> -->
        <form @submit.prevent="emit('submitted'); form.isDirty = false">

            <q-card bordered flat square class="bg-transparent">


                <q-card-section class="q-pt-xs" v-if="$slots.title || $slots.description || form.processing">

                    <!-- <div class="float-right">
                        <q-circular-progress v-if="form.processing"
                                :value="form.progress?.percentage"
                                size="50px" show-value font-size="10px" :thickness="0.35" color="teal" class="q-mt-xs">
                                track-color="grey-3"
                        {{ form.progress?.percentage }}%
                        </q-circular-progress>

                    </div> -->
                    <q-linear-progress v-if="form.processing" :value="form.progress?.percentage" color="teal" />
                    <!-- <q-linear-progress :value="12" color="teal" /> -->

                    <h5 v-if="$slots.title" class="q-my-none q-pt-md">
                        <slot name="title"></slot>
                    </h5>
                    <p v-if="$slots.description" class="text-caption q-mb-none">
                        <slot name="description"></slot>
                    </p>
                </q-card-section>
                
                <q-separator v-if="$slots.title || $slots.description || form.processing" />
                

                <q-card-actions v-if="form && form.isDirty && (doubleButtons || topButtonsOnly)" :align="!buttonsLeft ? 'right' : 'left'">

                    <JetButtonsActions :form="form" :show-action="showAction" :with-continue-action="withContinueAction" :no-show-btn-reset="noShowBtnReset"
                                        :buttons-left="buttonsLeft"
                                        :button-done-text="buttonDoneText" />

                    <q-separator />
                </q-card-actions>

                <div v-if="$slots.before_form">
                    <slot name=before-form></slot>
                </div>


                <!-- <q-card-section class="row"> -->
                <q-card-section class="row q-col-gutter-sm" @input="formHasChanged()">
                    <slot name="form"></slot>
                </q-card-section>

                <!-- <q-separator class="q-mt-lg" /> -->

                <!-- contenu supplémentaire -->
                <slot></slot>


                <q-card-actions v-if="form && form.isDirty && ! topButtonsOnly" :align="!buttonsLeft ? 'right' : 'left'">

                    <JetButtonsActions :form="form" :show-action="showAction" :with-continue-action="withContinueAction" :no-show-btn-reset="noShowBtnReset"
                                        :buttons-left="buttonsLeft"
                                        :button-done-text="buttonDoneText" />

                </q-card-actions>
            </q-card>
        </form>
    </div>
<!-- </div> -->
</template>

<script setup>
import {/*  defineAsyncComponent, defineComponent, */ onBeforeUnmount } from 'vue'

import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetButtonsActions from '@/Jetstream/ButtonsActions.vue'

const props = defineProps({
    form: {Object, default: {}},
    // classes: {String, default: 'col-md-8 col-lg-6 col-xl-6'},
    'show-action': {Boolean, default: true},
    // // 'disable-action': Boolean,
    // // 'no-title': Boolean,
    // // 'no-description': Boolean,
    // // 'has-input-number': Boolean,
    // 'show-attestation-honneur': Boolean,
    'with-continue-action': Boolean,
    'no-show-btn-reset': Boolean,
    'buttons-left': Boolean,
    'double-buttons': Boolean,
    'top-buttons-only': Boolean,
    'button-done-text': String,
    'full-width': Boolean,
})

const emit = defineEmits(['submitted'])


onBeforeUnmount(()=>{
    props.form.isDirty = false
})


const formHasChanged = ()=>{
    if( ! props.form.isDirty){
        props.form.isDirty = true
    }
}

const reset = ()=>{
    props.form.isDirty = false;

    if(_.isFunction(props.form.reset)){
        props.form.reset();
    }
}

/*
import { $ac } from '@helpers'

export default {
    name: 'FormSection',
    emits: ['submitted'],
    components: {
        JetActionMessage: $ac(()=>import('@/Jetstream/ActionMessage.vue')),
    },
    props:{
        form: {Object, default: {}},
        // classes: {String, default: 'col-md-8 col-lg-6 col-xl-6'},
        'show-action': {Boolean, default: true},
        // // 'disable-action': Boolean,
        // // 'no-title': Boolean,
        // // 'no-description': Boolean,
        // // 'has-input-number': Boolean,
        // 'show-attestation-honneur': Boolean,
        'with-continue-action': Boolean,
        'no-show-btn-reset': Boolean,
    },
    setup(props){

        // For control in helper link() in form isn't dirty before change page
// log('in FormSection', props.form)


        onBeforeUnmount(()=>{
            props.form.isDirty = false
        })

        return {

            formHasChanged:()=>{
                if( ! props.form.isDirty){
                    props.form.isDirty = true
                }
            },

            reset(){
                props.form.isDirty = false;

                if(_.isFunction(props.form.reset)){
                    props.form.reset();
                }
            }
        }
    }

} */
</script>
